'use strict';

import { openNotification } from './notifications';

export const addMaintenanceLog = (bedNumber, data) => {
    return fetch(`${process.env.REACT_APP_API_URL}/beds/${bedNumber}/maintenance-logs`, {
        method: 'POST',
        credentials: 'include',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(data),
    })
    .then(async res => {
        if (res.status === 201) return res.json();
        throw await res.json();
    })
    .then(res => {
        openNotification({ type: 'success', message: res.message });
        return true;
    })
    .catch(err => {
        openNotification({
            type: 'error',
            message: err.message || 'Erreur lors de l\'enregistrement de la maintenance',
        });
        return false;
    });
};

export const fetchMaintenanceLogs = (bedNumber) => {
    return fetch(`${process.env.REACT_APP_API_URL}/beds/${bedNumber}/maintenance-logs`, {
        method: 'GET',
        credentials: 'include',
        headers: new Headers({ 'Content-Type': 'application/json' }),
    })
    .then(async res => {
        if (res.status === 200) return res.json();
        throw await res.json();
    })
    .catch(err => {
        console.error('Erreur chargement historique maintenance:', err);
        return [];
    });
};

export const fetchMaintenanceSummary = () => {
    return fetch(`${process.env.REACT_APP_API_URL}/beds/maintenance/summary`, {
        method: 'GET',
        credentials: 'include',
        headers: new Headers({ 'Content-Type': 'application/json' }),
    })
    .then(async res => {
        if (res.status === 200) return res.json();
        throw await res.json();
    })
    .catch(err => {
        console.error('Erreur chargement suivi maintenance:', err);
        return {};
    });
};
